export enum AssignmentType {
    SupportUser = 1,
    DealerGroupUser = 2,
    DealerUser = 3,
    CustomerUser = 4,
    JobsiteUser = 5,
    EquipmentUser = 6,
    DealerGroupDealer = 7,
    DealerGroupCustomer = 8,
    DealerJobsite = 9,
    DealerCustomer = 10,
    JobsiteDealer = 11,
    CustomerDealer = 12,
    Unknown = 13
}

export class AssignData {
    public Id: number = 0;
    public Type: AssignmentType = AssignmentType.Unknown;
    public AssignmentId: number = 0;
}

export class AccessOption {
    public Id: number;
    public Name: string;
}

export class ResultMessage {
    public Id: number = 0;
    public OperationSucceed: boolean = false;
    public LastMessage: string = "";
    public ActionLog: string = "";
}

export class ModifyRelationParam {
    public LeftId: number;
    public RightId: number;
    public Remove: boolean;
}

export class AppRoute {
    routeEventTime: Date = new Date(0);
    routeId: number = 0;
    routeLevel: number = 0;
    routePath: string = '';
    itemId: number = 0;
    hasParam: boolean = false;
    routeTitle: string = '';
}